'use client';

import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Grid } from '@repo/pandacss/jsx';
import { AnalyticsFeatureViewed as FeatureViewed } from '@repo/platform-analytics/AnalyticsFeatureViewed';
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { Skeleton } from '@repo/ui/Skeleton';
import type { ApprovalOddsValues } from '@/features/approval-odds/constants';
import { CardsApprovalLine } from './CardsApprovalLine';
import { approvalOddsSlotRecipe } from './styles';
export type CardsApprovalOddsProps = {
  approvalLikelihood: ApprovalOddsValues | null;
  isLoading?: boolean;
};
const CardsApprovalOdds = t0 => {
  const $ = _c(20);
  const {
    approvalLikelihood,
    isLoading
  } = t0;
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  const t1 = approvalLikelihood?.label ?? undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = approvalOddsSlotRecipe({
      likelihood: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    container
  } = t2;
  if (isLoading) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Skeleton css={{
        height: "[124px]"
      }} />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] !== approvalLikelihood?.label) {
    t3 = approvalLikelihood?.label?.toLowerCase();
    $[3] = approvalLikelihood?.label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== skuImpressionId || $[6] !== t3) {
    t4 = {
      additional_attributes: {
        approval_odds: t3,
        parent_activity_id: skuImpressionId
      }
    };
    $[5] = skuImpressionId;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = css({
      my: "1"
    });
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== approvalLikelihood) {
    t6 = <CardsApprovalLine approvalLikelihood={approvalLikelihood} />;
    $[9] = approvalLikelihood;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== container || $[12] !== t6) {
    t7 = <Grid columns={5} columnGap="1" className={container}>{t6}</Grid>;
    $[11] = container;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t8) {
    t9 = <FeatureViewed entityName="cc_approval_odds" entitySection="" impressionPosition={0} additionalAttributes={t4}>{t8}</FeatureViewed>;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default CardsApprovalOdds;